export enum ProductAttribute {
    Preview = 'Preview',
    Test = 'Test',
}
